import { UserRolePermission } from '@schooly/api';
import { newDateTimezoneOffset } from '@schooly/utils/date';
import { isWithinInterval } from 'date-fns';

export const canViewJustifications = (permissions: UserRolePermission[]) => {
  return permissions.includes('attendance_viewer');
};

export const canEditRegister = (permissions: UserRolePermission[]) => {
  return permissions.includes('attendance_manager');
};

export const canEditAttendanceEntries = (permissions: UserRolePermission[]) => {
  return permissions.includes('attendance_manager') || permissions.includes('attendance_creator');
};

export const isRegisterDateEditable = (
  registerDate: string,
  validity: { start: string; end: string },
) =>
  isWithinInterval(newDateTimezoneOffset(registerDate), {
    start: newDateTimezoneOffset(validity.start),
    end: newDateTimezoneOffset(validity.end),
  });
